export default (name) => {
  if (!name) return '';
  
  const split = name.split(' ');
  let initials = '';
  for (let i = 0; i < split.length; i += 1) {
    initials += split[i].substring(0, 1);
  }
  return initials.toUpperCase();
};
